import React from 'react'
import { useDispatch } from 'react-redux'

import { BasicModal } from '@/components/layout/modals/BasicModal'
import { AbstractForm } from '@/components/forms/formik/AbstractForm'
import { updatePlaybookOrganization } from '@/reducers/playbooks/playbooks.actions'
import { getOrganizationOptions } from '@/utils/helpers'

import { PlaybookDeleteForm } from './PlaybookDeleteForm'
import { EditPlaybookVisibilityModal } from './EditPlaybookVisibilityModal'

export const PlaybooksPageModals = ({
  activeModal,
  activeRow,
  closeActiveModal,
  organizations,
  playbooks,
  isBaltoAdmin,
  currentUserOrgId,
}) => {
  const dispatch = useDispatch()

  if (!activeModal || !activeRow) {
    return null
  }

  const getPlaybookDeleteOptions = (cid) => {
    return playbooks
      .filter((playbook) => playbook.cid !== cid)
      .filter((playbook) => {
        if (!isBaltoAdmin) {
          return playbook.organization_id === currentUserOrgId
        }
        return true
      })
      .map((playbook) => ({ value: playbook.cid, label: playbook.name }))
  }

  return (
    <>
      {activeModal === 'updateOrganization' && (
        <BasicModal
          title="Update Playbook Organization"
          onClose={closeActiveModal}
          show
          size="tiny"
        >
          <AbstractForm
            existingValues={{ organization_id: activeRow.organization_id }}
            schema={[
              {
                name: 'organization_id',
                type: 'select',
                label: 'Organization',
                options: getOrganizationOptions(organizations),
                required: true,
              },
            ]}
            onSubmit={(formValues) => {
              dispatch(updatePlaybookOrganization(formValues.organization_id, activeRow.cid))
              closeActiveModal()
            }}
            buttonLabel="Save"
            onClose={closeActiveModal}
            isModal
          />
        </BasicModal>
      )}

      {activeModal === 'visibility' && (
        <EditPlaybookVisibilityModal
          playbookCid={activeRow.cid}
          playbookName={activeRow.name}
          onClose={closeActiveModal}
        />
      )}

      {activeModal === 'deletePlaybook' && (
        <PlaybookDeleteForm
          playbookCid={activeRow.cid}
          playbookOptions={getPlaybookDeleteOptions(activeRow.cid)}
          onClose={closeActiveModal}
        />
      )}
    </>
  )
}
